module.exports = __webpack_public_path__ + "img/product_category_preview-4.44d8fdb.jpg";